import { render, staticRenderFns } from "./SecondComponent.vue?vue&type=template&id=6d5d1240"
import script from "./SecondComponent.vue?vue&type=script&lang=js"
export * from "./SecondComponent.vue?vue&type=script&lang=js"
import style0 from "./SecondComponent.vue?vue&type=style&index=0&id=6d5d1240&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports